export function isWX () {
	let ua = window.navigator.userAgent.toLowerCase()
    let match = ua.match(/MicroMessenger/i)
    if (match && match[0] === 'micromessenger') {
        return true
    } else {
        return false
    }
}
export function isApp () {
    return !isWX() && (typeof window.webkit !== 'undefined' || typeof window.JsMode !== 'undefined')
}
export function isAndroid () {
    if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
        return true
    } else {
        return false
    }
}
export function isIOS () {
	if (!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
	    return true
	} else {
	    return false
	}
}
